
import Vue from "vue";
import Component from "vue-class-component";
import { BModal, BAlert } from "bootstrap-vue";
import { Prop } from "vue-property-decorator";


@Component({
    components: {
        BAlert
    }
})
export default class SignatureModal extends Vue
{
    @Prop({ type: Function, required: true })
    save!: (file: File) => void;

    hasConnection = false;
    waitingForSignature = false;
    isError = false;
    signatureSrc = "";
    blob = "";

    $refs!: { bModal: BModal };

    baseUrl = "https://127.0.0.1:8000";

    mounted()
    {
        this.$refs.bModal.$on("hide", () => this.reset());
    }

    private sendFile()
    {
        const file = this.base64ToFile(this.signatureSrc, "user-signature.png");
        this.save(file);
        this.hideModal();
    }

    private hideModal()
    {
        this.$refs.bModal.hide();
        this.reset();
    }

    private async onModalOpen()
    {
        await this.startSignaturePad();
    }

    //#region Signature pad API functions
    private async startSignaturePad()
    {
        this.signatureSrc = "";
        await this.execute(`${this.baseUrl}/startallkiri`, this.startSignaturePadResponse);
    }

    private startSignaturePadResponse()
    {
        this.waitingForSignature = true;
        this.hasConnection = true;
    }

    private async getSignature()
    {
        await this.execute(`${this.baseUrl}/pilt`, this.getSignatureResponse);
    }

    private getSignatureResponse(body: string)
    {
        this.signatureSrc = 'data:image/png;base64,' + body;
        this.waitingForSignature = false;
        this.blob = body;
    }

    //#endregion

    private reset()
    {
        this.waitingForSignature = false;
        this.signatureSrc = "";
        this.hasConnection = false;
        this.blob = "";
    }


    private base64ToFile(base64String: string, fileName: string): File
    {
        const mimeType = base64String.match(/data:(.*);base64/)?.[1] || "image/png";
        const byteCharacters = atob(base64String.split(",")[1]);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++)
        {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        return new File([blob], fileName, { type: mimeType });
    }

    async execute(url: string, callback: (response: string) => void)
    {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);

        try
        {
            const response = await fetch(`${url}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'text/plain',
                },
            });
            clearTimeout(timeout);
            if (!response.ok)
            {
                this.isError = true;
                throw new Error(await response.text());
            }
            this.isError = false;
            const responseBody = await response.text();
            callback(responseBody);
        } catch (error)
        {
            this.isError = true;
            this.reset();
            console.log(error);
        }
    }

}
